import React from 'react';
import ReactDOM from 'react-dom/client';
import BearingSearch from './BearingSearch';
import { AuthenticationProvider } from '../../my-dashboard/context/AuthenticationContext';
import { ProjectProvider } from '../../my-dashboard/project-details/context/ProjectContext';
import ToastNotification from '../../my-dashboard/components/toast/ToastNotification';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-search',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<AuthenticationProvider>
				<ProjectProvider>
					<BearingSearch />

					<ToastNotification />
				</ProjectProvider>
			</AuthenticationProvider>
		</React.StrictMode>
	);
}
